module.exports = __webpack_public_path__ + "img/code-13.bd0a3aab.png";